import { Button, Container, Grid, TextField } from '@mui/material';
import React, { Fragment, useContext } from 'react';
import axios from 'axios'

import PageHeader from '../helper/PageHeader';
import Alert from '@mui/material/Alert';
import { authContext } from '../../context/AuthContext';
import { useEffect, useState } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

const { REACT_APP_USER_STOREFRONT } = process.env;
const { REACT_APP_EMPLOYER_STOREFRONT } = process.env;

const EMarket = props => {
    const user = useContext(authContext).user
    const history = useHistory()
    const location = useLocation()
    const params = useParams()
    const eMarketURL = (props.user) ? REACT_APP_USER_STOREFRONT : REACT_APP_EMPLOYER_STOREFRONT;
    const msgAdd = (props.user) ? 'is ' : 'and employer name are ';

    const [employerName, setEmployerName] = useState(null); 

    const {t} = props;
    // the header text and redirect URL (for success page redirect button)
    const header = props.employer ? t('EMarket.PurchaseEmployerCredit') : t('EMarket.PurchaseCredit')
    const eMarketWarningMessage = props.employer ? t('EMarket.EmployerWarning') : t('EMarket.UserWarning') + user.name 
    console.log (eMarketWarningMessage)
    useEffect(() => {        
        async function getData() {
            try {
                let res = await axios.get('/api/userGroup/' + params.id);
                console.log(res.data.usergroup.name)
                if (res.data.group) {
                    setEmployerName(res.data.usergroup.name);
                }
            } catch(err) {
                console.log("API fails");
            }
        }
        
        if (props.employer) {
            // getData();
            let selectedEmployer =  JSON.parse(sessionStorage.getItem('selectedEmployer'));
            setEmployerName(selectedEmployer.label);
            console.log(selectedEmployer);
        }

        // redirects to training page of dashboard (/dashboard) if a user. 
        // Otherwise to the employer page
        console.log("props user: " + props.user);
        let redirect = (props.user) ? '/dashboard' : '/dashboard/employer/trainee/' + params.id
        console.log("redirect to",redirect)
        sessionStorage.setItem('paymentRedirect', redirect)

        console.log(eMarketURL)
    }, [])

    const onPay = () => {

        let data = {};

        if (props.employer) {
            data = {
                isEmployerPurchase: true,
                employerID: params.id,
                employerName: employerName
            }

        } else {
            data = {
                isEmployerPurchase: false,
                employerID: null,
                employerName: null
            }
        }

        let token = sessionStorage.getItem('accessToken');

        axios('/api/eMarket/log/' + user.username, {
            method: 'POST',
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        });

        window.location.href = eMarketURL;
        //history.push(eMarketURL);
    };


    return (
        <Fragment>
            <PageHeader
                title={header}
                cancel={history.goBack}
            />
                <Container maxWidth="lg">
                    {(location.state && props.employer) &&
                        <Alert severity="info">You have ${location.state.credit} credit. You can add as much as you need in one purchase.</Alert>
                    }
                    <br/>
                    <Alert severity="warning">{eMarketWarningMessage}</Alert>
                    <br/>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            id="GIBMP_username"
                            label={"Username:"}
                            defaultValue={user.username}
                            fullWidth
                            InputProps={{
                                readOnly: true,
                            }}
                            variant="filled"
                        />
                    </Grid>
                    {(props.employer && employerName) &&
                        <Grid item xs={12} sm={4}>
                            <TextField
                                id="employerName"
                                label={"Employer Name:"}
                                defaultValue={employerName}
                                fullWidth
                                InputProps={{
                                    readOnly: true,
                                }}
                                variant="filled"
                            />
                        </Grid>
                    }

                    <Grid item xs={12} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={[].join(' ')}
                            onClick={ onPay}
                        >
                            {t('EMarket.PAY')}
                        </Button>

                    </Grid>

                </Container>
        </Fragment>
    );

}

export default withTranslation()(EMarket);
